import { message } from 'antd';
import { config } from 'util/config';
import { httpClient, uploadClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

export function getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ defaultFormData: { userState: parameter } });
  //Tab组件里, sectionComponent.child.current 是对应的渲染分选组件
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  sectionComponent.setState({ componentDefaultValue });

  sectionComponent.child.map((child, i) => {
    if (child.current != null && child.current?.props.section.name === 'CompanyUser') {
      child.current?.setState({ searchParameter: { userState: parameter }, userState: parameter });
      child.current?.child.current?.setState({ userState: parameter });

      if (child.current?.customForm.current != null) {
        child.current?.customForm.current?.setState({ componentDataSource: [] });
      }

      setTimeout(() => {
        child.current?.getSectionDataByDefault();
      }, config.setTimeoutMilliSecond);
    }
  })
}

export function addBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.child.map((child, i) => {
    if (child.current != null && child.current?.child.current?.props.sectionName === 'CompanyUser') {
      // 重置 ColorPicker 显式清除标志，防止上一次操作残留影响新建表单
      child.current?.setState({ showModal: true, componentType: 'Create', isFormModified: false, removeColorMap: {} });

      setTimeout(() => {
        child.current?.customForm.current?.formRef.current?.resetFields();
        let componentDataSource = child.current?.customForm.current?.state.componentDataSource;
        child.current?.props.section.componentList.filter(c => c.type === 'Create')[0].groupList.forEach(group => {
          group.uieList.forEach(uie => {
            switch (uie.component) {
              case 'Select':
                let option = {};
                if (uie.component === 'Select' && uie.type !== 'multiple') {
                  if (componentDataSource[uie.source] !== undefined) {
                    if (uie.type === 'group') {
                      componentDataSource[uie.source].some(group => {
                        if (group.SelectOptionList === null) {
                          option = group;
                          return true;
                        }
                        return group.SelectOptionList.some(selectOption => {
                          option = selectOption;
                          return true;
                        });
                      });
                    } else {
                      option = componentDataSource[uie.source][0];
                    }
                  }
                  if (componentDataSource[uie.source] !== undefined) {
                    child.current?.customForm.current?.formRef.current?.setFieldValue(uie.source, option.Value);
                  }
                }
                break;
              case 'ColorPicker':
                child.current?.customForm.current?.formRef.current?.setFieldValue(uie.source, config.component.ColorPicker.defaultColor);
                break;
            }
          });
        });
        setTimeout(() => {
          child.current?.customForm.current?.additionalFormRef.current?.child.current?.setState({ signaturePreview: null, fileList: [], signatureRemoved: false });
        }, config.setTimeoutMilliSecond * 5);
      }, config.setTimeoutMilliSecond);
    }
  })
}

//点击修改密码按钮
export function changePassword({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ showModalChangePassword: true, companyUserId: parameter.CompanyUserId });
}

//修改密码提交表单
export function submitChangePassword({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ changePasswordFormSubmitting: true });
  var form = pageComponent.formRef.current?.getFieldsValue();
  httpClient
    .post('Admin/CompanyUser/ChangePassword/' + pageComponent.state.companyUserId, form)
    .then(({ data }) => {
      if (data.result) {
        pageComponent.formRef.current?.resetFields();
        pageComponent.setState({ showModalChangePassword: false, changePasswordFormSubmitting: false });
        message.success('Reset password successful');
      } else {
        globalFunction.handleResultError(data, pageComponent);
        pageComponent.setState({ changePasswordFormSubmitting: false });
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
      pageComponent.setState({ changePasswordFormSubmitting: false });
    });
}

// 强制目标用户的现有 JWT 全部失效。
export function signOutAllDevices({ parameter, pageComponent } = {}) {
  globalFunction.confirm({
    title: 'Sign Out All Devices',
    content: 'Are you sure you want to sign this user out from all devices? They will need to sign in again.',
    okText: 'Sign Out',
    okType: 'danger',
    callback: function () {
      httpClient
        .post('Admin/CompanyUser/SignOutAllDevices/' + parameter.CompanyUserId)
        .then(({ data }) => {
          if (data.result) {
            message.success('The user has been signed out from all devices.');
          } else {
            globalFunction.handleResultError(data, pageComponent);
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
        });
    }
  });
}

//点击打开Registration界面
export function manageRegistration({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ showModalManageRegistration: true, companyUserId: parameter.CompanyUserId });
  pageComponent.getRegistrationData(parameter.CompanyUserId);
}

//Registration提交表单
export function submitRegistrationForm({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ registrationFormSubmitting: true });
  var form = pageComponent.registrationFormRef.current?.getFieldsValue();
  form.CompanyUserId = pageComponent.state.companyUserId;
  switch (pageComponent.state.componentType) {
    case 'Create':
      httpClient
        .post('/Admin/CompanyUserRegNo/', form)
        .then(({ data }) => {
          if (data.result) {
            pageComponent.registrationFormRef.current?.resetFields();
            pageComponent.setState({ registrationFormSubmitting: false });
            setTimeout(() => {
              pageComponent.setState({ showModalRegistrationForm: false, componentType: '' });
              pageComponent.getRegistrationData(pageComponent.state.companyUserId);

              pageComponent.createPage.current?.child[0].current?.child.map((child, i) => {
                console.log(child.current);
                if (child.current != null && child.current?.props.section.name === 'CompanyUser') {
                  child.current?.getSectionDataByDefault();
                }
              })
            }, config.setTimeoutMilliSecond);
          } else {
            globalFunction.handleResultError(data);
            sectionComponent.setState({ registrationFormSubmitting: false });
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
          sectionComponent.setState({ registrationFormSubmitting: false });
        });
      break;
    case 'Edit':
      form.key = pageComponent.state.companyUserRegNoId;
      httpClient
        .put('/Admin/CompanyUserRegNo/', form)
        .then(({ data }) => {
          if (data.result) {
            pageComponent.registrationFormRef.current?.resetFields();
            pageComponent.setState({ registrationFormSubmitting: false });
            setTimeout(() => {
              pageComponent.setState({ showModalRegistrationForm: false, componentType: '' });
              pageComponent.getRegistrationData(pageComponent.state.companyUserId);

              pageComponent.createPage.current?.child[0].current?.child.map((child, i) => {
                console.log(child.current);
                if (child.current != null && child.current?.props.section.name === 'CompanyUser') {
                  child.current?.getSectionDataByDefault();
                }
              })
            }, config.setTimeoutMilliSecond);
          } else {
            globalFunction.handleResultError(data);
            sectionComponent.setState({ registrationFormSubmitting: false });
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
          sectionComponent.setState({ registrationFormSubmitting: false });
        });
      break;
  }
}

//点击编辑时
export function editBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ dataLoading: true });
  sectionComponent.setState({ showModal: true, componentType: 'Edit' });

  setTimeout(() => {
    sectionComponent.customForm.current?.setState({ autoLoadComponentDataSource: false });
    sectionComponent.customForm.current?.getComponentDataSource();
    httpClient
      .get(pageComponent.props.areaName + '/' + sectionName + '/' + parameter.key)
      .then(({ data }) => {
        if (data.result) {
          sectionComponent.customForm.current?.setState({ currentDataKey: data.data.key });
          //处理不适合antd组件的数据
          let componentDataSource = sectionComponent.customForm.current?.state.componentDataSource;
          sectionComponent.props.section.componentList.filter(c => c.type === 'Edit')[0].groupList.forEach(group => {
            group.uieList.forEach(uie => {
              switch (uie.component) {
                case 'Select':
                  //处理Select默认选项, 如果字段的值是null且备选项列表已加载, 则自动选择备选项里第一个(如果已有数据, 则加载备选项里有的那一条)
                  if ((data.data[uie.source] === null || data.data[uie.source] === undefined) && componentDataSource[uie.source] !== undefined) {
                    if (uie.type === null || uie.type.indexOf('multiple') < 0) {
                      data.data[uie.source] = componentDataSource[uie.source][0].Value;
                    }
                    if (uie.type !== null && uie.type.indexOf('multiple') >= 0) {
                      data.data[uie.source] = [];
                    }
                  }
                  break;
                case 'RichTextEditor':
                  //处理RichTextEditor, 如果是null或者undefined，改为空字符串，否则会崩溃
                  if (data.data[uie.source] === null) {
                    data.data[uie.source] = '';
                  }
                  break;
                case 'Input':
                  //处理Input, 如果type是fileName, 处理成改文件名的状态
                  if (uie.type === 'fileName') {
                    uie.addonAfter = globalFunction.getExtension(data.data[uie.source]);
                    data.data[uie.source] = globalFunction.getFileNameWithoutExtension(data.data[uie.source]);
                  }
                  break;
                case 'ColorPicker':
                  if (data.data[uie.source] === null) {
                    data.data[uie.source] = config.component.ColorPicker.defaultColor
                  }
                  break;
              }
            });
          });
          //把处理后的数据赋值给表单
          sectionComponent.customForm.current?.formRef.current?.setFieldsValue(data.data);
          sectionComponent.customForm.current?.setState({ formData: data.data });
          sectionComponent.setState({ dataLoading: false, isFormModified: false });

          let fileList = [];
          if (data.data.Signature !== null) {
            // 把原始的signature放入文件数组，这样重新提交时也能保存回去
            let binaryString = window.atob(data.data.Signature);
            let binaryLen = binaryString.length;
            let bytes = new Uint8Array(binaryLen);
            for (let i = 0; i < binaryLen; i++) {
              let ascii = binaryString.charCodeAt(i);
              bytes[i] = ascii;
            }

            let blob = new Blob([bytes], { type: 'application/octet-stream' });
            let file = new File([blob], 'signature.png', { type: 'application/octet-stream', lastModified: Date.now() });
            fileList.push(file);
          }
          if (sectionComponent.customForm.current?.additionalFormRef.current !== null) {
            // 重新打开 Edit 弹窗时把 signatureRemoved 也重置，避免上一次 Cancel 之前点过 Remove 的状态被带过来
            sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ signaturePreview: data.data.Signature, fileList, signatureRemoved: false });
          }
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }, config.setTimeoutMilliSecond);
}

//特殊处理一些提交的条件
export function customFormOnSubmit({ parameter, sectionComponent, pageComponent, formComponent, sectionName, uie } = {}) {
  let values = sectionComponent.customForm.current?.formRef.current?.getFieldsValue();

  formComponent.props.component.groupList.filter(c => c.show).forEach(group => {
    group.uieList.forEach(uie => {
      if (uie.component === 'ColorPicker') {
        if (values[uie.source] !== undefined) {
          values[uie.source] = values[uie.source].hex
        } else {
          values[uie.source] = null;
        }
      }
    });
  });

  let formData = new FormData();
  for (let key in values) {
    if (values[key] !== undefined && values[key] !== null) {
      if (key !== 'CompanyRoleIdList' && key !== 'file') {
        formData.append(key, values[key]);
      }
    }
  }

  var i = 0;
  if (values.CompanyRoleIdList !== undefined) {
    values.CompanyRoleIdList.map(element => {
      formData.append('CompanyRoleIdList[' + i + ']', element);
      i++;
    });
  }

  if (sectionComponent.customForm.current?.additionalFormRef.current !== null) {
    const signatureForm = sectionComponent.customForm.current?.additionalFormRef.current?.child.current;
    signatureForm?.state.fileList.map((file) => {
      formData.append('files[]', file);
    });
    // 显式删除：用户点过 Remove Signature 时告诉后端清 DB（后端 BLL 默认 null 保护下需要这个显式信号）
    if (signatureForm?.state.signatureRemoved) {
      formData.append('RemoveSignature', 'true');
    }
    // 同步清掉 SignatureForm 的本地 state，避免 AntDraggableModal 没设 destroyOnClose 时
    // 提交后实例复用，残留的 fileList 被下一个用户的 Edit 弹窗读到（连续编辑多个用户时签名错乱/丢失的根因之一）
    signatureForm?.setState({ signaturePreview: null, fileList: [], signatureRemoved: false });
  }

  // 显式删除颜色：用户点过 ColorPicker 旁的 × 时，对应字段加 Remove{Source}=true（同 Signature 模式）
  // 后端 BLL 在 dataObj.BackgroundColor==null 时默认会保留 DB 值，需要这个显式信号才会清 DB
  const removeColorMap = sectionComponent.state.removeColorMap || {};
  Object.keys(removeColorMap).forEach(source => {
    if (removeColorMap[source]) {
      formData.append('Remove' + source, 'true');
    }
  });
  // 同步清掉本地标志，防止连续编辑多个用户时残留导致后续 Edit 误清空（同 signatureRemoved 的清理动机）
  sectionComponent.setState({ removeColorMap: {} });

  sectionComponent.setState({ submitting: true });

  switch (sectionComponent.state.componentType) {
    case 'Create':
      uploadClient
        .post('Admin/CompanyUser', formData)
        .then(({ data }) => {
          if (data.result) {
            sectionComponent.setState({ showModal: false, submitting: false });
            sectionComponent.getSectionDataByDefault();
          } else {
            if (data.code === 2) {
              message.error(data.message);
              sectionComponent.setState({ submitting: false });
            } else {
              globalFunction.handleResultError(data, pageComponent);
              sectionComponent.setState({ submitting: false });
            }
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
          sectionComponent.setState({ submitting: false });
        });
      break;
    case 'Edit':
      formData.append('key', sectionComponent.customForm.current?.state.currentDataKey);
      uploadClient
        .put('Admin/CompanyUser', formData)
        .then(({ data }) => {
          if (data.result) {
            sectionComponent.setState({ showModal: false, submitting: false });
            sectionComponent.getSectionDataByDefault();
          } else {
            if (data.code === 2) {
              message.error(data.message);
              sectionComponent.setState({ submitting: false });
            } else {
              globalFunction.handleResultError(data, pageComponent);
              sectionComponent.setState({ submitting: false });
            }
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
          sectionComponent.setState({ submitting: false });
        });
      break;
  }
}

// CompanyUser 专用 cancelCustomForm：覆盖 Common.cancelCustomForm（只 resetFields 不清 AdditionalForm 子 state）。
// 关闭弹窗时同步把 SignatureForm 的 fileList / signaturePreview 清掉；
// 否则 AntDraggableModal 没 destroyOnClose 时实例复用，下一次 Edit 弹窗会读到上一个用户的残留签名文件，
// 配合后端的 null 保护会被解读为"未改动"而被错误地保留显示给当前用户。
export function cancelCustomForm({ sectionComponent } = {}) {
  sectionComponent.setState({ showModal: false, customFormSubmitting: false, isFormModified: false, componentType: null });
  setTimeout(() => {
    sectionComponent.customForm.current?.resetFields();
    sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ signaturePreview: null, fileList: [], signatureRemoved: false });
  }, config.setTimeoutMilliSecond);
}

//从其他User拷贝EmailSignature
export function copyEmailSignatureFromOnChange({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  if (parameter > 0) {
    httpClient
      .get('/Admin/CompanyUser/' + parameter)
      .then(({ data }) => {
        if (data.result) {
          if (data.data.EmailSignature !== null) {
            sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ EmailSignature: data.data.EmailSignature });
          } else {
            sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ EmailSignature: '' });
          }
        } else {
          globalFunction.handleResultError(data);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

//Availability弹框
export function showAvailability({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  pageComponent.setState({ showModalAvailableDates: true, companyUserId: parameter.CompanyUserId, availabilityTitle: parameter.Name + ' - Not Available Dates' });
  pageComponent.getAvailabilityData(parameter.CompanyUserId);
}

//Availability提交表单
export function submitAvaiableForm({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ availableFormSubmitting: true });
  const isCrossingMidnight = !pageComponent.availableFormRef.current?.getFieldsValue().Date[0].isSame(pageComponent.availableFormRef.current?.getFieldsValue().Date[1], 'day');
  var form = pageComponent.availableFormRef.current?.getFieldsValue();
  form.StartDate = pageComponent.availableFormRef.current?.getFieldsValue().Date[0].format("DD/MM/YYYY HH:mm")
  form.EndDate = pageComponent.availableFormRef.current?.getFieldsValue().Date[1].format("DD/MM/YYYY HH:mm")
  form.CompanyUserId = pageComponent.state.companyUserId;
  if (!form.Repeat) {
    form.Type = null
    form.Times = 0
  }
  if (form.Type === 'Daily' && isCrossingMidnight) {
    message.warning('To add Avaiable time block, please set Start and End date as the same day.');
    pageComponent.setState({ availableFormSubmitting: false });
    return
  }


  switch (pageComponent.state.componentType) {
    case 'Create':
      httpClient
        .post('/Admin/CompanyUserNotAvailability/', form)
        .then(({ data }) => {
          if (data.result) {
            pageComponent.availableFormRef.current?.resetFields();
            pageComponent.setState({ availableFormSubmitting: false });
            setTimeout(() => {
              pageComponent.setState({ showModalAvailableDatesForm: false, componentType: '' });
              pageComponent.getAvailabilityData(pageComponent.state.companyUserId);

              pageComponent.createPage.current?.child[0].current?.child.map((child, i) => {
                console.log(child.current);
                if (child.current != null && child.current?.props.section.name === 'CompanyUser') {
                  child.current?.getSectionDataByDefault();
                }
              })
            }, config.setTimeoutMilliSecond);
          } else {
            globalFunction.handleResultError(data);
            pageComponent.setState({ availableFormSubmitting: false });
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
          pageComponent.setState({ availableFormSubmitting: false });
        });
      break;
    case 'Edit':
      form.key = pageComponent.state.companyUserRegNoId;
      httpClient
        .put('/Admin/CompanyUserNotAvailability/', form)
        .then(({ data }) => {
          if (data.result) {
            pageComponent.availableFormRef.current?.resetFields();
            pageComponent.setState({ availableFormSubmitting: false });
            setTimeout(() => {
              pageComponent.setState({ showModalAvailableDatesForm: false, componentType: '' });
              pageComponent.getAvailabilityData(pageComponent.state.companyUserId);

              pageComponent.createPage.current?.child[0].current?.child.map((child, i) => {
                console.log(child.current);
                if (child.current != null && child.current?.props.section.name === 'CompanyUser') {
                  child.current?.getSectionDataByDefault();
                }
              })
            }, config.setTimeoutMilliSecond);
          } else {
            globalFunction.handleResultError(data);
            pageComponent.setState({ availableFormSubmitting: false });
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
          pageComponent.setState({ availableFormSubmitting: false });
        });
      break;
  }
}
